import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'

import { GlobalContext } from 'store/global'

interface Props {
  children: React.ReactElement
}

export const CanAccessCustomerReports = ({
  children,
}: Props): React.ReactElement => {
  const [{ canDownloadPartnerDataSharingReports }] = useContext(GlobalContext)

  return canDownloadPartnerDataSharingReports ? (
    children
  ) : (
    <Navigate to="/" state={{ returnTo: window.location.pathname }} />
  )
}
